import { useAuth } from "@/context/AuthContext";

const COLORS = ["bg-emerald-500", "bg-blue-500", "bg-amber-500", "bg-fuchsia-500", "bg-rose-500", "bg-cyan-500"];
const initials = (name) => (name || "?").trim().split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase();

// Full banner: shows avatars + text of who is working/reviewing.
export function PresenceIndicator({ viewers = [], label = "Trabajando ahora", testid }) {
  const { user } = useAuth();
  if (!viewers.length) return null;
  const names = viewers.map((v) => (v.user_id === user?.id ? "Tú" : v.name || "Usuario"));
  return (
    <div className="flex items-center gap-2.5 p-2.5 rounded-md bg-emerald-50 border border-emerald-200 text-emerald-800 text-sm" data-testid={testid || "presence-banner"}>
      <span className="relative flex h-2.5 w-2.5 shrink-0">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-70" />
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500" />
      </span>
      <div className="flex -space-x-1.5">
        {viewers.slice(0, 5).map((v, i) => (
          <span key={v.user_id} title={v.name} className={`w-6 h-6 rounded-full ${COLORS[i % COLORS.length]} text-white text-[10px] font-bold grid place-items-center ring-2 ring-emerald-50`}>
            {initials(v.name)}
          </span>
        ))}
      </div>
      <span className="font-medium">
        {label}: {names.join(", ")}
        {viewers.length > 1 ? " (colaborando)" : ""}
      </span>
    </div>
  );
}

// Compact inline chip for list rows.
export function PresenceChip({ viewers = [], testid }) {
  const { user } = useAuth();
  if (!viewers.length) return null;
  const names = viewers.map((v) => (v.user_id === user?.id ? "Tú" : v.name || "Usuario"));
  return (
    <span className="inline-flex items-center gap-1.5 text-[11px] font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full px-2 py-0.5" title={`Revisando: ${names.join(", ")}`} data-testid={testid || "presence-chip"}>
      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
      {names.length === 1 ? names[0] : `${names[0]} +${names.length - 1}`}
    </span>
  );
}
